import { Status_Enum as Status } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';

export const checkIsUnscheduled = (currentStatus?: Status) =>
  currentStatus === Status.DRAFT || currentStatus === Status.HIDDEN_DRAFT || currentStatus === Status.UNSPECIFIED;
